<template>
  <div>
    <b-btn v-if="$auth.user().isAdmin" @click="showAll = !showAll">показать все поля</b-btn>
    <vue-form-generator ref="form" :schema="schema" :model="model" :options="formOptions"> </vue-form-generator>
    <div v-if="!model.user_id && !$auth.user().isAdmin && objectsWithSubstance && objectsWithSubstance.length > 0">
      Заменить вещество {{ substance.name }} на создаваемую копию у объектов:
      <b-form-checkbox-group
        v-model="model.replaceIds"
        :options="objectsWithSubstance"
        class="mb-3"
        value-field="data"
        text-field="name"
      ></b-form-checkbox-group>
    </div>
    <b-button
      v-if="model.user_id == $auth.user().profile.user_id || $auth.user().isAdmin || !model.id"
      href="#"
      variant="success"
      @click="$emit('save', model)"
      ><span v-if="model.id">Сохранить</span><span v-else>Создать</span></b-button
    >
    <b-btn
      class="pull-right"
      @click="
        model.parentId = model.id;
        model.id = null;
        model.name = model.name + ' (копия)';
        model.user_id = $auth.user().profile.user_id;
        $emit('save', model);
      "
      v-if="model.id"
      variant="success"
      >Создать копию</b-btn
    >
  </div>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";

export default {
  name: "Liquid",
  components: {
    "vue-form-generator": VueFormGenerator.component,
  },
  props: {
    objectSubstances: Array,
    substance: Object,
    validator: Object,
  },
  computed: {
    objectsWithSubstance() {
      var objects = [];
      if (this.objectSubstances && this.substance) {
        var objs = this.objectSubstances.find((el) => el.id == this.substance.id);
        if (objs) {
          for (var obj of objs.objects) {
            objects.push({ name: obj.name, data: { objId: obj.id, type: obj.type } });
          }
        }
      }
      return objects;
    },
  },
  watch: {
    substance() {
      this.model = Object.assign({}, this.substance);
      this.$set(this.model, "replaceIds", []);
      if (this.objectsWithSubstance) {
        for (let obj of this.objectsWithSubstance) {
          this.model.replaceIds.push(obj.data);
        }
      }
    },
    validator() {
      this.$set(this.model, "validator", this.validator);
      this.$refs.form.validate();
    },
  },
  mounted() {
    this.model = Object.assign({}, this.substance);
    this.$set(this.model, "replaceIds", []);
    if (this.objectsWithSubstance) {
      for (let obj of this.objectsWithSubstance) {
        this.model.replaceIds.push(obj.data);
      }
    }
  },
  data() {
    return {
      showAll: false,
      model: {
        name: "Вещество",
        type: 2,
        M: 0,
        Tvsp: 0,
        A: 37,
        B: 1,
        Ca: 0,
        po: 0,
        Cnkpr: 0,
        Tkip: 0,
        class_of_combustible_substance: 0,
        param_B: 0,
        tttype: 1,
        m1: 0,
        Cp: 0,
        Lg: 0,
        Hsg: 0,
        replaceIds: [],
        validator: {},
      },

      schema: {
        groups: [
          {
            fields: [
              {
                type: "input",
                inputType: "text",
                label: "Название",
                model: "name",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Молярная масса, кг*кмоль^(-1)",
                model: "M",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Температура вспышки, С",
                model: "Tvsp",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Температура кипения, С",
                model: "Tkip",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Константа антуана A",
                model: "A",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Константа антуана B",
                model: "B",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Константа антуана Ca",
                model: "Ca",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Плотность, кг/м3",
                model: "po",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "НКПР, %(об)",
                model: "Cnkpr",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Класс чувствительности",
                model: "class_of_combustible_substance",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Корректировочный параметр",
                model: "param_B",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "select",
                selectOptions: {
                  hideNoneSelectedText: true,
                },
                inputType: "number",
                label: "Тип в соответствии с таблицей П3.4 приказа 404",
                model: "tttype",
                required: true,
                values: function () {
                  return [
                    { id: "3", name: "Бензин" },
                    { id: "4", name: "Дизельное топливо" },
                    { id: "5", name: "Нефть и нефтепродукты" },
                    { id: "6", name: "Другие" },
                  ];
                },
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Удельная массовая скорость выгорания, кг/(м2 с)",
                model: "m1",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  //visible if business is selected1 5 6 7 8 9
                  if (model.tttype == 5 || model.tttype == 6 || this.$parent.showAll) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Удельная теплота сгорания, МДж/кг",
                model: "Hsg",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  //visible if business is selected1 5 6 7 8 9
                  if (model.tttype == 6 || this.$parent.showAll) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },

              {
                type: "input",
                inputType: "number",
                label: "Удельная теплота испарения жидкости, кДж/кг",
                model: "Lg",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  //visible if business is selected1 5 6 7 8 9
                  if ((model.tttype == 6 && (!model.m1 || model.m1 <= 0)) || this.$parent.showAll) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Удельная теплоемкость жидкости, кДж/(кг*К)",
                model: "Cp",
                required: true,
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  //visible if business is selected1 5 6 7 8 9
                  if ((model.tttype == 6 && (!model.m1 || model.m1 <= 0)) || this.$parent.showAll) {
                    return true;
                  } else {
                    return false;
                  }
                },
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
};
</script>
